import React from 'react'

interface PaginationPageButtonProps {
  page: number
  isActive: boolean
  disabled?: boolean
  onClick: (page: number) => void
}

export const PaginationPageButton: React.FC<PaginationPageButtonProps> = ({
  page,
  isActive,
  disabled = false,
  onClick,
}) => {
  return (
    <button
      className={`tw-flex tw-h-9 tw-min-w-[2.25rem] tw-items-center tw-justify-center tw-rounded-md tw-border tw-px-3 tw-text-sm tw-font-medium tw-transition-all focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-focus-100 focus:tw-ring-offset-1 disabled:tw-cursor-not-allowed disabled:tw-opacity-40 ${
        isActive
          ? 'tw-border-focus-100 tw-bg-focus-100 tw-text-white hover:tw-bg-focus-100 hover:tw-bg-opacity-90'
          : 'tw-border-content-base tw-border-opacity-20 tw-bg-white tw-text-content-base hover:tw-bg-base-300 hover:tw-bg-opacity-50'
      }`}
      onClick={() => onClick(page)}
      disabled={disabled}
      aria-label={`Page ${page}`}
      aria-current={isActive ? 'page' : undefined}
    >
      {page}
    </button>
  )
}
